module.exports = __webpack_public_path__ + "static/media/icon-ok.3d390d5f.svg";